import React from 'react';
import { Check, Shield, ChevronDown, Star, Calendar, DollarSign, Frown, Dumbbell, Gamepad2, TrendingUp } from 'lucide-react';
import { Button, TrustBadges, SectionBadge } from './SharedUI';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/g6Y33Vh3LhAb2XH7amtTZz/Kit_de_entrenamiento_profesional_de_futbol.png';
export function Hero() {
  return <section className="pt-16 pb-12 md:pt-24 md:pb-20 px-4 max-w-5xl mx-auto text-center" data-id="element-66">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-navy-800 border border-navy-700 text-sm font-medium mb-8" data-id="element-67">
        <span data-id="element-68">⚽ +500 entrenadores ya lo usan</span>
        <span className="text-gray-500" data-id="element-69">·</span>
        <div className="flex items-center text-yellow-400" data-id="element-70">
          <Star className="w-4 h-4 fill-current" data-id="element-71" />
          <span className="ml-1 text-white" data-id="element-72">4.9/5</span>
        </div>
      </div>

      <h1 className="text-4xl md:text-6xl font-black leading-tight mb-6" data-id="element-73">
        Puedes ser un gran entrenador de fútbol…
        <br data-id="element-74" />
        <span className="text-brand-green" data-id="element-75">
          y aun así no llenar tus sesiones
        </span>
      </h1>

      <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-76">
        Descubre el sistema que los entrenadores que SÍ llenan su agenda están
        usando para conseguir más jugadores, cobrar lo que merecen y dejar de
        depender solo del boca a boca.
      </p>

      <div className="relative max-w-3xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl shadow-brand-green/10 border border-navy-700" data-id="element-77">
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-transparent to-transparent z-10" data-id="element-78"></div>
        <img src={PRODUCT_IMAGE} alt="Megapack Fútbol Listo" className="w-full h-auto object-cover" data-id="element-79" />
      </div>

      <div className="max-w-xl mx-auto" data-id="element-80">
        <Button scrollToOffer data-id="element-81">🔥 Quiero el Megapack ahora</Button>
        <TrustBadges data-id="element-82" />
      </div>
    </section>;
}
export function PainPoints() {
  return <section className="py-16 md:py-24 px-4 bg-navy-800/50 border-y border-navy-800" data-id="element-83">
      <div className="max-w-6xl mx-auto" data-id="element-84">
        <div className="text-center mb-12 md:mb-16" data-id="element-85">
          <SectionBadge data-id="element-86">Seamos honestos...</SectionBadge>
          <h2 className="text-3xl md:text-4xl font-bold max-w-2xl mx-auto" data-id="element-87">
            Esto es lo que nadie te dice sobre ser entrenador de fútbol
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-88">
          <div className="bg-navy-800 p-8 rounded-2xl border border-navy-700" data-id="element-89">
            <div className="text-4xl mb-4" data-id="element-90">📅</div>
            <h3 className="text-xl font-bold mb-3" data-id="element-91">
              Semanas llenas, semanas vacías
            </h3>
            <p className="text-gray-400" data-id="element-92">
              Tu agenda depende de la suerte, la época del año o si alguien te
              recomendó. No hay sistema. No hay previsibilidad.
            </p>
          </div>

          <div className="bg-navy-800 p-8 rounded-2xl border border-navy-700" data-id="element-93">
            <div className="text-4xl mb-4" data-id="element-94">💸</div>
            <h3 className="text-xl font-bold mb-3" data-id="element-95">
              Cobras lo mismo que hace 2 años
            </h3>
            <p className="text-gray-400" data-id="element-96">
              Sabes que vales más. Pero tienes miedo de subir el precio y perder
              los pocos alumnos que tienes.
            </p>
          </div>

          <div className="bg-navy-800 p-8 rounded-2xl border border-navy-700" data-id="element-97">
            <div className="text-4xl mb-4" data-id="element-98">😤</div>
            <h3 className="text-xl font-bold mb-3" data-id="element-99">
              Ves a otros con menos nivel ganar más
            </h3>
            <p className="text-gray-400" data-id="element-100">
              Entrenadores con menos experiencia que tú tienen listas de espera.
              Tú sigues esperando que el teléfono suene.
            </p>
          </div>
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-101">
          <p className="text-2xl md:text-3xl font-bold italic text-white" data-id="element-102">
            "No se trata de saber más de fútbol.
            <br data-id="element-103" />
            <span className="text-brand-green" data-id="element-104">
              Se trata de tener un sistema que trabaje por ti.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}
export function ProductReveal() {
  return <section className="py-16 md:py-24 px-4 text-center" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <SectionBadge data-id="element-107">LA SOLUCIÓN</SectionBadge>
        <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-108">
          Megapack Fútbol Listo
        </h2>
        <p className="text-xl md:text-2xl text-brand-green font-medium mb-8" data-id="element-109">
          Combo Completo — Todo lo que necesitas en un solo lugar
        </p>
        <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-110">
          5 tomos digitales con el sistema completo para entrenar mejor,
          conseguir más jugadores y cobrar lo que mereces. Acceso inmediato tras
          el pago.
        </p>
      </div>
    </section>;
}
export function WhatsInside() {
  const tomos = [{
    icon: '⚽',
    title: 'Tomo 1 - Técnica y Táctica Fundamental',
    desc: 'Fundamentos, postura, golpeos, sistemas de juego y patrones tácticos listos para enseñar.'
  }, {
    icon: '🎯',
    title: 'Tomo 2 - Golpes y Acciones Especiales',
    desc: 'Conducción, regate, centros, cabeceo y defensa individual con progresión de 3 niveles.'
  }, {
    icon: '🧠',
    title: 'Tomo 3 - Situaciones de Juego',
    desc: 'Transiciones, estrategia de partido, balón parado y el módulo completo de portería.'
  }, {
    icon: '📋',
    title: 'Tomo 4 - Sesiones Completas y Análisis de Rival',
    desc: '4 sesiones listas para usar + ficha de scouting y cómo explotar los puntos débiles del rival.'
  }, {
    icon: '🎁',
    title: 'Tomo 5 - Bonos Exclusivos',
    desc: 'Programa físico de 4 semanas + 5 juegos reducidos + recursos para llenar tu agenda.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800/30" data-id="element-111">
      <div className="max-w-5xl mx-auto" data-id="element-112">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-113">
          ¿Qué hay dentro del Megapack?
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-114">
          {tomos.map((tomo, i) => <div key={i} className={`bg-navy-800 p-6 rounded-2xl border border-navy-700 flex gap-4 ${i === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto w-full' : ''}`} data-id="element-115">
              <div className="text-3xl flex-shrink-0" data-id="element-116">{tomo.icon}</div>
              <div data-id="element-117">
                <h3 className="text-lg font-bold mb-2 text-white" data-id="element-118">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-119">
                  {tomo.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-green/10 border border-brand-green/30 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-120">
          <p className="text-brand-green font-bold text-lg md:text-xl" data-id="element-121">
            "Todo en formato digital. Descarga inmediata. Funciona desde el
            primer día."
          </p>
        </div>
      </div>
    </section>;
}
export function Bonuses() {
  return <section className="py-16 md:py-24 px-4" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <SectionBadge data-id="element-125">+ BONOS GRATIS POR HOY</SectionBadge>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-126">
          <div className="bg-navy-800 p-8 rounded-2xl border-2 border-brand-green relative overflow-hidden" data-id="element-127">
            <div className="absolute top-4 right-4 bg-brand-green text-navy-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-128">
              GRATIS
            </div>
            <Dumbbell className="w-10 h-10 text-brand-green mb-4" data-id="element-129" />
            <h3 className="text-xl font-bold mb-3" data-id="element-130">
              Módulo de Físico Específico para Fútbol
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-131">
              Programa de 4 semanas + calentamiento listo para aplicar en cada
              sesión.
            </p>
          </div>

          <div className="bg-navy-800 p-8 rounded-2xl border-2 border-brand-green relative overflow-hidden" data-id="element-132">
            <div className="absolute top-4 right-4 bg-brand-green text-navy-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-133">
              GRATIS
            </div>
            <Gamepad2 className="w-10 h-10 text-brand-green mb-4" data-id="element-134" />
            <h3 className="text-xl font-bold mb-3" data-id="element-135">
              5 Juegos Reducidos con Reglas Completas
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-136">
              Ejercicios lúdicos que entrenan técnica, táctica y físico al mismo
              tiempo. Tus jugadores los van a pedir cada sesión.
            </p>
          </div>

          <div className="bg-navy-800 p-8 rounded-2xl border-2 border-brand-green relative overflow-hidden" data-id="element-137">
            <div className="absolute top-4 right-4 bg-brand-green text-navy-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-138">
              GRATIS
            </div>
            <TrendingUp className="w-10 h-10 text-brand-green mb-4" data-id="element-139" />
            <h3 className="text-xl font-bold mb-3" data-id="element-140">
              Recursos para Llenar tu Agenda
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-141">
              Ficha de seguimiento de jugadores, planificación de temporada y
              guía para conseguir más alumnos sin publicidad de pago.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
export function SocialProof() {
  const testimonials = [{
    quote: 'En 3 semanas conseguí 4 alumnos nuevos. Nunca había tenido tanta demanda.',
    name: 'Carlos M.',
    detail: '31 años · Madrid, España'
  }, {
    quote: 'Por fin tengo sesiones estructuradas que mis jugadores respetan y disfrutan.',
    name: 'Diego R.',
    detail: '27 años · Buenos Aires, Argentina'
  }, {
    quote: 'Subí mis precios un 40% y no perdí ni un alumno. Solo necesitaba el sistema.',
    name: 'Andrés P.',
    detail: '38 años · Santiago, Chile'
  }, {
    quote: 'Antes improvisaba cada sesión. Ahora entro a la pista con todo claro.',
    name: 'Roberto V.',
    detail: '44 años · Montevideo, Uruguay'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800/50" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-144">
          Lo que otros entrenadores ya están logrando
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-145">
          {testimonials.map((t, i) => <div key={i} className="bg-navy-800 p-8 rounded-2xl border border-navy-700" data-id="element-146">
              <div className="flex text-brand-green mb-4" data-id="element-147">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-148" />)}
              </div>
              <p className="text-lg font-medium mb-6 italic" data-id="element-149">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-150">
                <div className="w-10 h-10 rounded-full bg-navy-700 flex items-center justify-center font-bold text-brand-green" data-id="element-151">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-152">
                  <p className="font-bold text-white" data-id="element-153">{t.name}</p>
                  <p className="text-sm text-gray-400" data-id="element-154">{t.detail}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-16 md:py-24 px-4" data-id="element-155">
      <div className="max-w-3xl mx-auto text-center" data-id="element-156">
        <Shield className="w-20 h-20 text-brand-green mx-auto mb-6" data-id="element-157" />
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-158">
          Garantía de 45 días sin preguntas
        </h2>
        <p className="text-lg text-gray-300 leading-relaxed" data-id="element-159">
          Si en 45 días sientes que el Megapack no te ayudó, te devolvemos cada
          centavo. Sin formularios. Sin excusas. Nosotros asumimos todo el
          riesgo porque sabemos que funciona.
        </p>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Es un pago único o una suscripción?',
    a: 'Es un pago único. Pagas una vez y tienes acceso de por vida a todo el material, incluyendo futuras actualizaciones.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con un enlace para descargar todos los tomos y bonos en formato PDF de alta calidad.'
  }, {
    q: '¿Sirve si entreno a niños pequeños?',
    a: 'Sí, el sistema incluye progresiones y adaptaciones que funcionan desde categorías formativas hasta niveles más avanzados.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes 45 días de garantía incondicional. Si no te convence, nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800/30 border-t border-navy-800" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <h2 className="text-3xl font-bold text-center mb-10" data-id="element-162">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-163">
          {faqs.map((faq, i) => <details key={i} className="group bg-navy-800 rounded-xl border border-navy-700 overflow-hidden" data-id="element-164">
              <summary className="flex justify-between items-center font-bold cursor-pointer list-none p-6 text-lg" data-id="element-165">
                <span data-id="element-166">{faq.q}</span>
                <span className="transition group-open:rotate-180" data-id="element-167">
                  <ChevronDown className="w-5 h-5 text-brand-green" data-id="element-168" />
                </span>
              </summary>
              <div className="text-gray-400 p-6 pt-0 leading-relaxed" data-id="element-169">
                {faq.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="py-12 px-4 text-center border-t border-navy-800 text-gray-500 text-sm" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <p className="mb-2" data-id="element-172">
          © 2024 Megapack Fútbol Listo. Todos los derechos reservados.
        </p>
        <p data-id="element-173">
          Este producto es un bien digital descargable. No se realizan envíos
          físicos.
        </p>
        <p className="mt-6 text-xs text-gray-600 max-w-2xl mx-auto" data-id="element-174">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}